var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26430",
    "data-name": "Group 26430",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 301.836,
    height: 44.821,
    viewBox: "0 0 301.836 44.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677",
    "data-name": "Rectangle 2677",
    width: 103.15,
    height: 33.821,
    fill: "#0f1b30"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26427",
    "data-name": "Group 26427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26426",
    "data-name": "Group 26426",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52249",
    "data-name": "Path 52249",
    d: "M25.36,11.943H13.22v3.572H21.86c-.422,5.008-4.589,7.144-8.522,7.144A9.386,9.386,0,0,1,3.915,13.15a9.4,9.4,0,0,1,9.434-9.569,9.264,9.264,0,0,1,6.435,2.581l2.5-2.59A12.714,12.714,0,0,0,13.222,0,13.337,13.337,0,0,0,0,13.086,13.294,13.294,0,0,0,13.412,26.239c7.024,0,12.166-4.812,12.166-11.928a10.706,10.706,0,0,0-.218-2.369Z",
    transform: "translate(0 0.001)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52250",
    "data-name": "Path 52250",
    d: "M268.962,89.748a8.434,8.434,0,1,0,8.463,8.463,8.333,8.333,0,0,0-8.463-8.463m.049,3.313a5.131,5.131,0,1,1-4.826,5.1,4.849,4.849,0,0,1,4.826-5.1",
    transform: "translate(-233.325 -80.391)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52251",
    "data-name": "Path 52251",
    d: "M444.814,89.748a8.434,8.434,0,1,0,8.463,8.463,8.333,8.333,0,0,0-8.463-8.463m.049,3.313a5.131,5.131,0,1,1-4.826,5.1A4.849,4.849,0,0,1,444.863,93.061Z",
    transform: "translate(-390.843 -80.391)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52252",
    "data-name": "Path 52252",
    d: "M621.559,89.834a8.444,8.444,0,0,0-.078,16.869,5.571,5.571,0,0,0,4.625-2.049v1.663c0,2.91-1.767,4.652-4.433,4.652a4.676,4.676,0,0,1-4.317-3l-3.241,1.355a8.113,8.113,0,0,0,7.585,4.967c4.507,0,7.942-2.839,7.942-8.793V90.133h-3.536V91.77a5.965,5.965,0,0,0-4.547-1.935Zm.328,3.306c2.223,0,4.5,1.9,4.5,5.139,0,3.294-2.277,5.11-4.554,5.11a4.792,4.792,0,0,1-4.666-5.078,4.86,4.86,0,0,1,4.715-5.17Z",
    transform: "translate(-549.502 -80.468)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52253",
    "data-name": "Path 52253",
    d: "M848.853,89.641c-4.276,0-7.867,3.4-7.867,8.422a8.156,8.156,0,0,0,8.277,8.463,8.556,8.556,0,0,0,7.065-3.7l-2.915-1.94a4.72,4.72,0,0,1-4.132,2.322,4.338,4.338,0,0,1-4.136-2.556l11.308-4.692-.587-1.375a7.636,7.636,0,0,0-7.013-4.942ZM849,92.884a3.361,3.361,0,0,1,3.121,1.8l-7.552,3.156A4.685,4.685,0,0,1,849,92.884",
    transform: "translate(-753.303 -80.295)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2676",
    "data-name": "Rectangle 2676",
    width: 3.464,
    height: 24.858,
    transform: "translate(82.5 0.872)",
    fill: "#0f1b30"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26429",
    "data-name": "Group 26429",
    transform: "translate(164.546 2.796)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rated_excellent_by_our_clients",
    "data-name": "Rated excellent by our clients",
    transform: "translate(3.411 40.025)",
    fill: "#0f1b30",
    fontSize: 9,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Rated excellent by our clients")), /*#__PURE__*/React.createElement("g", {
    id: "Group_26428",
    "data-name": "Group 26428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M12.365,0l4.142,7.411L24.729,9.12l-5.662,6.289.94,8.467-7.642-3.524L4.723,23.876l.94-8.467L0,9.12,8.222,7.411Z",
    transform: "translate(112.56)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M12.365,0l4.142,7.411L24.729,9.12l-5.662,6.289.94,8.467-7.642-3.524L4.723,23.876l.94-8.467L0,9.12,8.222,7.411Z",
    transform: "translate(84.42)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M12.365,0l4.142,7.411L24.729,9.12l-5.662,6.289.94,8.467-7.642-3.524L4.723,23.876l.94-8.467L0,9.12,8.222,7.411Z",
    transform: "translate(56.28)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M12.365,0l4.142,7.411L24.729,9.12l-5.662,6.289.94,8.467-7.642-3.524L4.723,23.876l.94-8.467L0,9.12,8.222,7.411Z",
    transform: "translate(28.14)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M12.365,0l4.142,7.411L24.729,9.12l-5.662,6.289.94,8.467-7.642-3.524L4.723,23.876l.94-8.467L0,9.12,8.222,7.411Z",
    fill: "#0f1b30"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52254",
    "data-name": "Path 52254",
    d: "M-6717,8555v25.255",
    transform: "translate(6850.848 -8552.204)",
    fill: "none",
    stroke: "#11192a",
    strokeWidth: 2,
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleRating);
export default __webpack_public_path__ + "static/media/Google-Rating.f94e8c7366c15cc03e2e889885eefc55.svg";
export { ForwardRef as ReactComponent };